import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/mastiff-zimowy.jpg'
import _imports_1 from '@/assets/images/safe-animal-900.jpg'


const _hoisted_1 = { class: "container bg-dark-section p-5 text-center" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "container bg-light-section p-5" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 text-center" }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 mt-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-100"
  })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_11 = { class: "mt-5" }
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-5" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://www.safe-animal.eu" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "LOGO",
      style: {"max-width":"100%"}
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("i", null, [
        _createElementVNode("span", {
          innerHTML: _ctx.translate('message.home.header_text')
        }, null, 8, _hoisted_2)
      ]),
      _hoisted_3,
      _createElementVNode("p", null, [
        _createElementVNode("span", {
          innerHTML: _ctx.translate('message.home.content_text')
        }, null, 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("a", {
            href: `/${_ctx.i18nConst.getLocale()}/puppies`,
            style: {"color":"#f77f00"}
          }, [
            _createElementVNode("h1", null, [
              _createElementVNode("b", null, _toDisplayString(_ctx.translate("message.home.attention_we_have_puppies")), 1)
            ])
          ], 8, _hoisted_8)
        ]),
        _hoisted_9
      ]),
      _hoisted_10,
      _createElementVNode("p", _hoisted_11, [
        _createElementVNode("a", {
          href: `/${_ctx.i18nConst.getLocale()}/puppies`
        }, _toDisplayString(_ctx.translate("message.home.we_have_puppies")) + " »", 9, _hoisted_12)
      ]),
      _hoisted_13
    ])
  ], 64))
}